export const downloadObject = {
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "DOWNLOAD",
  headline: "アプリをダウンロード",
  description:
    "Workom をダウンロードいただき、ありがとうございます。新しい匿名 SNS で社会人と交流しよう！",
  src: "images/download.svg",
  alt: "not-found",
  topPadding: false,
  largeImage: true,
};
